export default __webpack_public_path__ + "static/media/S-047.ef4d7247.png";